import { isProdEnv } from '@/utils/isProdEnv'

/*
 * We're going to store all the UI variables here, so we don't have to maintain them in the pipeline or AWS
 * Given these variables are already exposed to UI, it's not useful to have them in the pipeline
 * Below is just a starting point, I will make this solid and improve on a separate task here R2-4280
 * TODO : Implement R2-4280 : Improve the envs, see if we can use a library, also migrate all the ones defined in the pipeline here
 * */
export const env = {
  customerio_write_key: {
    dev: '8d7b5590b5fe27139975',
    prod: '703db1df72032ff37b76',
  },
  segment_write_key: {
    dev: 'GEgnCEIXLmoYOfezyp4H8DCOvp01Yk0z',
    prod: '92tXOvqHtT5rQpDBPsX3GDoMBu3H5XfG',
  },
  lyka_url: {
    dev: 'https://lykadev.com.au',
    prod: 'https://lyka.com.au',
  },
  mixpanel_token: {
    dev: '593c49bc8f7831232546cbf580f066cd',
    prod: '00d69201b2bc9a2b0c3b28429b39b7a2',
  },
}

export const getEnvVariable = (varName: keyof typeof env) => {
  const variable = env[varName]
  return isProdEnv() ? variable.prod : variable.dev
}
